/*
 *
 * FlowTemplate
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 05-Sep-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
// import { useLocation } from 'react-router-dom'
import formattedMessage from './languageModule'
// import { checkPathConfig } from './templateConfig'
import Toggle from 'Hoc/ToggleComponent'
import MerchantNavigationFlow from '@nexidigital/merchantnavigationflow'
import MerchantFlowHeadings from '@nexidigital/merchantflowheadings'
import MerchantFlowCard from '@nexidigital/merchantflowcard'
import FlowButtons from '@nexidigital/flowbuttons'
import MerchantFooter from '@nexidigital/merchantfooter'
import { flowPopupMapType } from 'Utility/flowPopupMap'
import { Capacitor } from '@capacitor/core'
import appEnvRemap from 'Utility/appEnvRemap'
import { openUrl } from '../../../utils/globalMethods'
import './FlowTemplate.scss'

const FlowTemplate = (props) => {
  // const location = useLocation()

  // const pathConfig = checkPathConfig(location.pathname)
  // const isNexiTheme = document.documentElement.getAttribute('data-theme') === 'nexi'

  const handleClose = () => {
    if (props.onClickClose) {
      return props.onClickClose()
    }

    props.actions.doHideToast()
    props.actions.doShowPopup(flowPopupMapType.GENERIC_POPUP, {
      title: props.popupTitle ? props.popupTitle : formattedMessage['closeModal.title'],
      description: props.popupDescription ? props.popupDescription : formattedMessage['closeModal.description'],
      onClose: props.actions.doHidePopup,
      primaryButtonLabel: props.popuPrimaryButtonLabel
        ? props.popuPrimaryButtonLabel
        : formattedMessage['closeModal.primaryButtonLabel'],
      primaryAction: () => {
        if (props.popupPrimaryAction) {
          props.popupPrimaryAction()
          props.actions.doHidePopup()
        } else {
          window.location.replace(appEnvRemap.REDIRECT_PATH_LOGIN)
          props.actions.doHidePopup()
        }
      },
      secondaryButtonLabel: props.popuSecondaryButtonLabel
        ? props.popuSecondaryButtonLabel
        : formattedMessage['closeModal.secondaryButtonLabel'],
      secondaryAction: () => {
        if (props.popupSecondaryAction) {
          props.popupSecondaryAction()
          props.actions.doHidePopup()
        } else {
          props.actions.doHidePopup()
        }
      },
      children: typeof props.popupChildren === 'function' ? props.popupChildren() : props.popupChildren
    })
  }

  return (
    <Toggle>
      <>
        <div className={`flowTemplate ${props.flowBackground ? 'flowBg' : ''} ${props.firstLevel ? 'footer' : ''} ${(Capacitor.isNativePlatform() && props.firstLevel) ? 'appFooterTemplate' : ''}`}>
          <MerchantNavigationFlow
            title={props.titleNavigation}
            onClickBack={props.onClickBack}
            iconCloseLeft={props.iconCloseLeft}
            labelButtonLeft={props.labelButtonLeftNav}
            onClickClose={handleClose}
            labelButtonRight={props.labelButtonRightNav}
            iconCloseRight={props.iconCloseRight}
            childrenNav={props.childrenNav}
            withMenu={props.withMenu}
            menuKey={props.menuKey}
            onClickMenu={props.onClickMenu}
            iconNameMenu={props.iconNameMenu}
            labelMenu={props.labelMenu}
            support={props.support && !props.withMenu}
            invert={props.invert}
          />
          {(props.titlePage || props.subtitlePage) && <MerchantFlowHeadings title={props.titlePage} subtitle={props.subtitlePage} />}
          {!props.hideCardAndButtons
            ? (
              <>
                <div className={`flowContent ${props.pages ? 'pages' : ''} ${props.support ? 'support' : ''} ${props.emptyPage ? 'emptyPage' : ''} ${props.longScroll ? 'longScroll' : ''} `}>
                  {props.titleCard
                    ? (
                      <MerchantFlowCard
                        title={props.titleCard}
                        subtitle={props.subtitleCard}
                        accordion={props.accordionCard}
                        disabled={props.disabledCard}
                        requiredLabel={props.requiredLabel}
                      >
                        {props.children}
                      </MerchantFlowCard>
                      )
                    : (
                        props.children
                      )}
                </div>
                {props.labelPrimaryButton && (
                  <FlowButtons
                    labelSecondary={props.labelSecondaryButton}
                    labelPrimary={props.labelPrimaryButton}
                    anchorLabel={props.anchorLabel}
                    textMsg={props.textMsg}
                    onClickPrimary={() => {
                      props.actions.doHideToast()
                      props.onClickPrimary()
                    }}
                    onClickSecondary={() => {
                      props.actions.doHideToast()
                      props.onClickSecondary()
                    }}
                    isPrimaryDisabled={props.isPrimaryDisabled}
                    isPrimaryLoading={props.isPrimaryLoading}
                    idPrimary={props.idPrimary || 'primaryButton'}
                    idSecondary={props.idSecondary || 'secondaryButton'}
                    iconPrimary={props.iconPrimary}
                    iconSecondary={props.iconSecondary}
                  />
                )}
              </>
              )
            : props.children}

        </div>
        {props.firstLevel && (
          <div className={`footerContext ${Capacitor.isNativePlatform() ? 'app' : ''} ${(Capacitor.isNativePlatform() && props.firstLevel) ? 'appFooterTemplate' : ''}`}>
            <MerchantFooter
              bank={props.bank}
              links={props.footerLinks}
              copyrightLabel={formattedMessage.copyrightLabel}
              app={Capacitor.isNativePlatform()}
              onClickLinkApp={(link) => openUrl(link)}
            // light={isNexiTheme}
            />
          </div>
        )}
      </>

    </Toggle>
  )
}

FlowTemplate.propTypes = {
  // Add here some propTypes
  // This props is expecting an object. Expose redux actions mapped by container.
  actions: PropTypes.shape({
    doShowPopup: PropTypes.func,
    doHidePopup: PropTypes.func,
    doHideToast: PropTypes.func
  }),
  // This props is expecting a string. It's the title of the navigation
  titleNavigation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string. It's the icon for the right close button
  iconCloseRight: PropTypes.node,
  // This props is expecting a string. It's the icon for the left close button
  iconCloseLeft: PropTypes.node,
  // This props is expecting a string or an object. It's the label for the left navigation button
  labelButtonLeftNav: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string or an object. It's the label for the right navigation button
  labelButtonRightNav: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a node. It's the children of the navigation
  childrenNav: PropTypes.node,
  // This props is expecting a node. It's the children of the page
  titlePage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string or an object. It's the subtitle of the page
  subtitlePage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string or an object. It's the title of the card
  titleCard: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string or an object. It's the subtitle of the card
  subtitleCard: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a boolean. It's the accordion of the card
  accordionCard: PropTypes.bool,
  // This props is expecting a boolean. It's the disabled of the card
  disabledCard: PropTypes.bool,
  // This props is expecting a string or an object. It's the required label of the card
  requiredLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string or an object\. It's the id of the button
  idButton: PropTypes.string,
  // This props is expecting a string or an object. It's the size of the button
  size: PropTypes.string,
  // This props is expecting a function. It's the onClick of the button
  onClickButton: PropTypes.func,
  // This props is expecting a boolean. It's the disabled of the button
  isButtonDisabled: PropTypes.bool,
  // This props is expecting a boolean. It's the loading of the button
  isButtonLoading: PropTypes.bool,
  // This props is expecting a boolean. It's the loading of the button
  onClickClose: PropTypes.func,
  // This props is expecting a boolean. It's the loading of the button
  onClickClosePopupPrimary: PropTypes.func,
  // This props is expecting a boolean. It's the loading of the button
  onClickClosePopupSecondary: PropTypes.func,
  // This props is expecting a boolean. It's the loading of the button
  onClickBack: PropTypes.func,
  // This props is expecting a node. It's the children of the page
  children: PropTypes.node,
  // This props is expecting a string or an object. It's the label for the secondary button
  labelSecondaryButton: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string or an object. It's the label for the primary button
  labelPrimaryButton: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string or an object. It's the label for the anchor
  anchorLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string or an object. It's the text message
  textMsg: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a function. It's the onClick of the primary button
  onClickPrimary: PropTypes.func,
  // This props is expecting a function. It's the onClick of the secondary button
  onClickSecondary: PropTypes.func,
  // This props is expecting a boolean. It's the disabled of the primary button
  isPrimaryDisabled: PropTypes.bool,
  // This props is expecting a boolean. It's the loading of the primary button
  isPrimaryLoading: PropTypes.bool,
  // This props is expecting a string. It's the id of the primary button
  idPrimary: PropTypes.string,
  // This props is expecting a string. It's the id of the secondary button
  idSecondary: PropTypes.string,
  // This props is expecting a boolean. It's the flow background
  flowBackground: PropTypes.bool,
  // This props is expecting a string or an object. It's the interrupt popup title
  popupTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string or an object. It's the interrupt popup description
  popupDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a string or an object. It's the interrupt popup primary button label
  popuPrimaryButtonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a function. It's the interrupt popup primary action
  popupPrimaryAction: PropTypes.func,
  // This props is expecting a string or an object. It's the interrupt popup secondary button label
  popuSecondaryButtonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a function. It's the interrupt popup secondary action
  popupSecondaryAction: PropTypes.func,
  // This props is expecting a function or a node. It's the children of the popup
  popupChildren: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  // This props is expecting a boolean. It's the with menu
  withMenu: PropTypes.bool,
  // This props is expecting a string. It's the menu key
  menuKey: PropTypes.string,
  // This props is expecting a function. It's the onClick of the menu
  onClickMenu: PropTypes.func,
  // This props is expecting a node. It's the icon of the menu
  iconNameMenu: PropTypes.node,
  // This props is expecting a string or an object. It's the label of the menu
  labelMenu: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // This props is expecting a boolean. It's the pages
  pages: PropTypes.bool,
  // This props is expecting a boolean. It's the info page status, without margin and padding
  emptyPage: PropTypes.bool,
  // This props is expecting a boolean.
  firstLevel: PropTypes.bool,
  // This props is expecting a string.
  bank: PropTypes.string,
  // This props is expecting an array.
  footerLinks: PropTypes.array,
  // This props is expecting a boolean. It's rappresent the support page
  support: PropTypes.bool,
  // This props is expecting a boolean. It's rappresent the invert status of the menu
  invert: PropTypes.bool,
  // This props is expecting a boolean. It's rappresent if card and buttons need to be hidden
  hideCardAndButtons: PropTypes.bool,
  // This props is expecting a node. It's the children of the page
  iconPrimary: PropTypes.node,
  // This props is expecting a node. It's the icon of the secondary button
  iconSecondary: PropTypes.node,
  // This props is expecting a boolean. It's the long scroll status
  longScroll: PropTypes.bool
}

FlowTemplate.defaultProps = {
  // Add here some default propTypes values
  actions: {
    doShowPopup: () => { },
    doHidePopup: () => { },
    doHideToast: () => { }
  },
  titleNavigation: '',
  iconCloseRight: '',
  iconCloseLeft: '',
  labelButtonLeftNav: '',
  labelButtonRightNav: '',
  childrenNav: null,
  titlePage: '',
  subtitlePage: '',
  titleCard: '',
  subtitleCard: '',
  accordionCard: false,
  disabledCard: false,
  requiredLabel: '',
  idButton: '',
  size: '',
  onClickButton: undefined,
  onClickClosePopupPrimary: undefined,
  onClickClosePopupSecondary: undefined,
  isButtonDisabled: false,
  isButtonLoading: false,
  onClickClose: undefined,
  onClickBack: undefined,
  children: null,
  labelSecondaryButton: '',
  labelPrimaryButton: '',
  anchorLabel: '',
  textMsg: '',
  onClickPrimary: undefined,
  onClickSecondary: undefined,
  isPrimaryDisabled: false,
  isPrimaryLoading: false,
  idPrimary: '',
  idSecondary: '',
  flowBackground: false,
  support: false,
  invert: false,
  popupTitle: '',
  popupDescription: '',
  popuPrimaryButtonLabel: '',
  popupPrimaryAction: undefined,
  popuSecondaryButtonLabel: '',
  popupSecondaryAction: undefined,
  showPopupChildren: false,
  popupChildren: null,
  withMenu: false,
  menuKey: '',
  onClickMenu: undefined,
  iconNameMenu: null,
  labelMenu: '',
  pages: false,
  emptyPage: false,
  firstLevel: false,
  bank: '',
  footerLinks: [],
  hideCardAndButtons: false,
  iconPrimary: null,
  iconSecondary: null,
  longScroll: false
}

export default React.memo(FlowTemplate)
